import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useFetch } from '@/hooks/useFetch';
import { activeEventsByShaliachIdUrl } from '@/constants';
import { Event } from '@sm-dashboard/types';

export interface HeatmapCenter {
  id: number;
  title: string;
  addressLine1?: string;
  addressLine2?: string;
  city?: string;
  phoneNumber: string;
  email: string;
  website?: string;
  focus: string;
  lat: number;
  lng: number;
}

/**
 * Hook to fetch events (centers) data for the current shaliach and convert geom coordinates to lat/lng
 */
export const useCentersData = () => {
  const [searchParams] = useSearchParams();
  const { data, loading, error, fetchData } = useFetch();
  const [centers, setCenters] = useState<HeatmapCenter[]>([]);
  const shaliachId = searchParams.get('shaliachId');

  useEffect(() => {
    const url = shaliachId ? `${activeEventsByShaliachIdUrl}?shaliachId=${shaliachId}` : activeEventsByShaliachIdUrl;
    fetchData({
      url,
      method: 'GET'
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shaliachId]);

  useEffect(() => {
    if (data) {
      // The API returns { rows: Event[], count: number }
      const eventsData = (data as { rows?: Event[]; count?: number }).rows || (Array.isArray(data) ? data : []);

      // Convert events with valid geom to HeatmapCenter format
      const validCenters: HeatmapCenter[] = eventsData
        .filter((event: Event) => {
          // Check if geom exists and has coordinates
          return (
            event.geom &&
            event.geom.coordinates &&
            Array.isArray(event.geom.coordinates) &&
            event.geom.coordinates.length >= 2
          );
        })
        .map((event: Event) => {
          // geom.coordinates is [longitude, latitude]
          const [lng, lat] = event.geom.coordinates;

          return {
            id: event.id,
            title: event.title || 'ללא שם',
            addressLine1: event.address || undefined,
            addressLine2: undefined,
            city: undefined,
            phoneNumber: event.phone || '',
            email: '',
            website: event.link || undefined,
            focus: event.description || event.content || '',
            lat,
            lng
          };
        });

      setCenters(validCenters);
    }
  }, [data]);

  return {
    centers,
    loading,
    error
  };
};
